var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 43,
    viewBox: "0 0 172 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_64_203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.1551 33.2865C70.1551 37.9171 64.7741 42.9947 60.3991 42.9947H0V9.70813C0 5.18405 4.3644 0 9.76135 0H70.1551V33.2865Z",
    fill: "#F7A823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9453 33.4567H76.5154V34.3242C76.5154 35.5324 77.1595 36.1126 79.2405 36.1126H84.4139C86.8356 36.1126 87.5489 35.5803 87.5489 33.8293C87.5489 32.2804 86.9368 31.8919 84.8557 31.8919H81.6622C76.574 31.8919 74.9027 31.5832 74.9027 28.3152C74.9027 25.505 76.574 24.8716 80.0123 24.8716H83.6049C87.7458 24.8716 88.7837 25.9361 88.7837 28.1289V28.5547H87.1869C87.155 26.5961 86.9527 26.2341 82.5724 26.2341H80.8053C77.5852 26.2341 76.4409 26.4044 76.4409 28.4323C76.4409 29.896 76.904 30.3909 79.5066 30.3909H84.4459C87.6979 30.3909 89.0604 31.3277 89.0604 33.4247V34.2231C89.0604 37.2569 86.5749 37.4751 84.1052 37.4751H79.5439C77.1062 37.4751 74.9613 37.0493 74.9613 34.3615L74.9453 33.4567Z",
    fill: "#1D1D1B",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7376 29.4915C91.7376 26.3725 92.8021 24.8716 96.1339 24.8716H102.521C105.549 24.8716 106.385 26.2874 106.385 27.9373V29.0018H104.921V28.4376C104.921 26.3459 103.628 26.2395 102.095 26.2395H96.3043C94.7075 26.2395 93.4088 26.7185 93.4088 28.8634V33.4939C93.4088 35.6229 94.7022 36.1179 96.3043 36.1179H102.159C104.41 36.1179 105.054 35.6442 105.054 33.9889V33.2225H106.651V34.0581C106.651 36.2882 105.933 37.4964 102.478 37.4964H96.1339C92.7968 37.4964 91.7376 36.0008 91.7376 32.8819V29.4915Z",
    fill: "#1D1D1B",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.195 25.0098H119.058C122.618 25.0098 123.177 26.186 123.177 28.5013V29.5072C123.177 31.2424 122.193 31.7214 120.915 31.8385V31.8704C122.618 32.1791 123.044 33.0626 123.044 34.191V37.3419H121.474V34.6327C121.474 32.706 120.537 32.4665 119.02 32.4665H110.866V37.3419H109.195V25.0098ZM118.871 31.1093C120.729 31.1093 121.533 30.6143 121.533 29.3156V28.2032C121.533 26.8247 120.937 26.3829 118.483 26.3829H110.866V31.1199L118.871 31.1093Z",
    fill: "#1D1D1B",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.11 25.0098H138.218V26.3723H127.781V30.3322H137.809V31.6948H127.781V36.0059H138.288V37.3685H126.11V25.0098Z",
    fill: "#1D1D1B",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.826 25.0098H152.935V26.3723H142.492V30.3322H152.525V31.6948H142.492V36.0059H152.994V37.3685H140.826V25.0098Z",
    fill: "#1D1D1B",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.437 25.0098H157.927L169.216 35.8409V25.0098H170.888V37.3419H168.397L157.108 26.5107V37.3419H155.437V25.0098Z",
    fill: "#1D1D1B",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9217 25.0098H21.0715C23.3229 25.0098 24.6003 25.4835 24.6003 28.3629C24.6003 31.104 24.3768 32.4878 20.7522 32.4878H12.5929V37.3419H10.9217V25.0098ZM22.9291 28.2032C22.9291 26.7396 22.1307 26.3829 20.683 26.3829H12.5929V31.1359H20.8161C22.1467 31.1359 22.9451 30.6569 22.9451 29.3795L22.9291 28.2032Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5909 29.4861C26.5909 26.3725 27.6554 24.8716 30.9873 24.8716H38.0874C41.4246 24.8716 42.4837 26.3725 42.4837 29.4861V32.8606C42.4837 35.9795 41.4192 37.4751 38.0874 37.4751H30.9873C27.6501 37.4751 26.5909 35.9795 26.5909 32.8606V29.4861ZM40.8125 28.8581C40.8125 26.7291 39.5191 26.2341 37.9171 26.2341H31.1576C29.5608 26.2341 28.2622 26.7132 28.2622 28.8581V33.4886C28.2622 35.6176 29.5555 36.1126 31.1576 36.1126H37.9171C39.5138 36.1126 40.8125 35.6336 40.8125 33.4886V28.8581Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1237 33.4567H46.6885V34.3242C46.6885 35.5324 47.3378 36.1126 49.4135 36.1126H54.5923C57.0087 36.1126 57.7272 35.5803 57.7272 33.8293C57.7272 32.2804 57.1098 31.8919 55.034 31.8919H51.8672C46.7736 31.8919 45.1077 31.5832 45.1077 28.3152C45.1077 25.505 46.7736 24.8716 50.2172 24.8716H53.8099C57.9454 24.8716 58.9833 25.9361 58.9833 28.1236V28.5494H57.4185C57.3866 26.5907 57.179 26.2341 52.8039 26.2341H51.0316C47.8115 26.2341 46.6725 26.4044 46.6725 28.4323C46.6725 29.896 47.1302 30.3909 49.7382 30.3909H54.6774C57.9295 30.3909 59.292 31.3277 59.292 33.4247V34.2231C59.292 37.2516 56.8064 37.4751 54.3368 37.4751H49.7063C47.2686 37.4751 45.1237 37.0493 45.1237 34.3615V33.4567Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7575 35.229H65.663V37.358H63.7575V35.229Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_64_203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 171.148,
    height: 43,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPos);
export default __webpack_public_path__ + "static/media/pos.f0c4ee8d9343f338a4344f4eeee25157.svg";
export { ForwardRef as ReactComponent };